import o from"@mui/system/useTheme";import r from"@mui/material/useMediaQuery";function n({type:s="up",size:t="sm"}){let e=o();return{matches:r(e.breakpoints[s](t,null)),breakpoints:e.breakpoints}}export{n as default};
